import { ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { MatDatepicker, MatDatepickerContent, MAT_SINGLE_DATE_SELECTION_MODEL_PROVIDER, DateRange } from '@angular/material/datepicker';

/**
 * @extends
 * Ce composant est une extension du MatDatepicker pour rendre accessible la référence du mat datepicker content.
 */
@Component({
  selector: 'wiz-datepicker',
  template: '',
  exportAs: 'wizDatepicker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [MAT_SINGLE_DATE_SELECTION_MODEL_PROVIDER],
})
export class  WizMatDatepicker<D> extends MatDatepicker<D> {

  /**
   * stockage de la référence de l'element mat-datepicker-content
   */
  public matContent: ElementRef;

  /**
   * @override
   * Transmet les valeurs pertinentes du datepicker à son contenu à l'intérieur de l'overlay.
   * l'override de cette methode permet de rendre accessible la référence du mat datepicker content
   * pour l'enregistrement dans le focus manager
   */
  protected _forwardContentValues(instance: MatDatepickerContent<D | null, D>) {
    instance.datepicker = this;
    instance.color = this.color;
    instance['_model'] = this['_model'];
    this.matContent = instance._elementRef;
  }

}
